module.exports = __webpack_public_path__ + "static/media/logout.91e388a5.png";